import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxLoaderModule } from '@tusharghoshbd/ngx-loader';
import { AuthModuleModule } from './auth-module/auth-module.module';
import { PublicModuleModule } from './public-module/public-module.module';
import { SharedModuleModule } from './shared-module/shared-module.module';
import { DhwaniLoginDefaultModule } from 'dhwani-login-default';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AdminModule } from './admin/admin.module';
import { LoaderComponent } from './loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderInterceptor } from './loader.interceptor';
// import {MatPaginatorModule} from '@angular/material/paginator';
// import {MatRadioModule} from '@angular/material/radio';
// import { NgCircleProgressModule } from 'ng-circle-progress';
@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxLoaderModule,
    AuthModuleModule,
    PublicModuleModule,
    SharedModuleModule,
    DhwaniLoginDefaultModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    AdminModule,
    MatProgressSpinnerModule,
    // MatPaginatorModule
    // MatRadioModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
